export default "__VITE_ASSET__DmjsNX_D__"